import React, { Component } from 'react'
import './Side.css';
import { theme } from '../../Theme';
import Icon from '@material-ui/core/Icon';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Link,
} from "react-router-dom";
import SideOptions from "./SideOptions";
import { AuthContext } from "../../context/authContext";

class Side extends Component {

  state = {
    open: false,
  }

  hasAccess(access = []) {
    if(this.context.is_admin) { return true }
    return this.context.access.some(a => access.includes(a))
  }

  isChildren(option) {
    let access = option.children.map(c => c.access).flat(1);
    access = access.filter(a => !!a)
    return this.hasAccess(access);
  }

  renderMenu(options = [], color) {
    // console.log(this.context)
    return (
      <div style={{ width: '100%', backgroundColor: `#1d2733` }} >
        {
          options.map((option, index) => {
            const key = `${index}-${option.link}`;
            if ((option.type === 'link' && !this.hasAccess(option.access)) || (option.type === 'children' && !this.isChildren(option)) || option.hidden) {
              return <span key={key} />
            }
            return (<div key={key}>
              {
                {
                  'text': (<div className='side-item-text' >{option.label}</div>),
                  'children': (this.renderChildren(option, color)),
                  'link': (<Link
                    style={{ backgroundColor: `#1d2733` }}
                    className={`side-item-link ${key === this.state.activeIndex && 'active'}`}
                    to={option.link || '#'}
                    onClick={() => { this.setState({ activeIndex: key, open: false }) }} >
                    {option.label}
                  </Link>)
                }[option.type]
              }
            </div>
            )
          })
        }
      </div>
    )
  }

  renderChildren(option, color) {
    return (
      <Accordion className="side-item-collapse" defaultExpanded={true} style={{ width: '100%', backgroundColor: `#1d2733` }} >
        <AccordionSummary
          expandIcon={<Icon style={{ color: '#fff' }} >expand_more</Icon>}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className="collapse-summary side-item-text"
        >
          {option.label}
        </AccordionSummary>
        <AccordionDetails>
          {this.renderMenu(option.children, color)}
        </AccordionDetails>
      </Accordion>
    )
  }

  render() {
    const { open } = this.state;
    const { 
      prop: { color_1 }
    } = this.context; 
    return (
      <div className='side' >
        <div className={`main ${(open) ? 'open' : ''}`} onClick={() => { this.setState({ open: false }) }}>
        </div>
        <div className={`sb ${(open) ? 'open' : ''}`} style={{ borderColor: theme.palette.primary.main, backgroundColor: `#1d2733` }}>
          <div style={{ textAlign: 'center' }}>
            <Link to={'/'}>
              <img alt='logo' src={this.context.prop.logo_url} className="sistem-logo" />
            </Link>
          </div>
          <h4 className="sistem-title" >{this.context.prop.nombre_sistema}</h4>
          {
            this.renderMenu(SideOptions, color_1)
          }
        </div>
        <div className={`sb-toggle ${(open) ? 'open' : ''}`}>
          <Icon hidden={!open} color="secondary" style={{ fontSize: 50, zIndex: 1000 }} onClick={() => { this.setState({ open: false }) }}>close</Icon>
          <Icon hidden={open} color="secondary" style={{ fontSize: 50, zIndex: 1000 }} onClick={() => { this.setState({ open: true }) }}>menu</Icon>
        </div>
      </div>
    )
  }
}
Side.contextType = AuthContext;

export default Side;
